// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"d525b6c1","366":"d96c5c71","718":"ae54bbba","837":"e3e001dc"}[chunkId] + ".css";
};